"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvmRpcProvider = void 0;
const api_1 = require("@polkadot/api");
const base_provider_1 = require("./base-provider");
const api_2 = require("@acala-network/api");
const temp_runtime_patch_1 = require("./utils/temp-runtime-patch");
class EvmRpcProvider extends base_provider_1.BaseProvider {
    constructor(endpoint, opts) {
        super(opts);
        const provider = new api_1.WsProvider(endpoint);
        // const api = new ApiPromise(options({ provider }));
        const api = new api_1.ApiPromise({
            ...(0, api_2.options)({ provider }),
            runtime: {
                ...(0, api_2.options)({ provider }).runtime,
                ...temp_runtime_patch_1.runtimePatch,
            },
        });
        this.setApi(api);
    }
    static from(endpoint, opt) {
        return new EvmRpcProvider(endpoint, opt);
    }
}
exports.EvmRpcProvider = EvmRpcProvider;
